import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'sdErrorParams',
  standalone: true,
})
export class ErrorParamsPipe implements PipeTransform {
  transform(errors: AbstractControl['errors']): { [key: string]: any } | undefined {
    if (!errors) {
      return undefined;
    }

    return Object.values(errors)[0];
  }
}
